<div
    class="relative flex w-full justify-center min-h-screen overflow-hidden"
    [ngClass]="{
        'bg-gradient-to-b from-primary-700 to-primary-900': isOnInitialStep(),
        'bg-gradient-to-t from-primary-500 from-[5vh] to-tertiary-50 to-[25vh]':
            !isOnInitialStep(),
    }"
>
    @if (step() === INITIAL_STEP) {
        <div class="overview-step-container md:max-w-[55vh]">
            <app-go-overview-intro @fade></app-go-overview-intro>
        </div>
    } @else {
        <div class="overview-step-container md:max-w-[40vh]">
            @switch (step()) {
                @case (1) {
                    <app-go-overview-step-one @fade></app-go-overview-step-one>
                }
                @case (2) {
                    <app-go-overview-step-two @fade></app-go-overview-step-two>
                }
                @case (LAST_STEP) {
                    <app-go-overview-step-three
                        @fade
                    ></app-go-overview-step-three>
                }
            }
        </div>
    }

    <app-go-overview-navigation
        [step]="step()"
        (stepChange)="stepChange()"
        [stepRange]="STEP_RANGE"
        [initialStep]="INITIAL_STEP"
    ></app-go-overview-navigation>
</div>
